import { I18nPluralPipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'recipeTime',
	standalone: true
})
@Injectable({
	providedIn: 'root',
})
export class RecipeTimePipe implements PipeTransform {
	constructor(private pluralPipe: I18nPluralPipe) { }

	/**
	 * Takes a time in minutes and formats it the form of `x hr(s) y min(s)`
	 *
	 * E.g. 30 -> `30 mins`, 121 -> `2 hrs 1 min`
	 * @param value Time in minutes
	 */
	transform(value: number): string {
		let output = '';
		// take the absolute since this pipe returns durations
		const absValue = Math.abs(value);
		// Short circuit if passed 0 minutes
		if (absValue === 0) {
			return '0 mins';
		}

		const hours = Math.floor(absValue / 60);
		const mins = absValue % 60;
		if (hours) {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			output += this.pluralPipe.transform(hours, { '=1': '# hr ', other: '# hrs ' });
		}
		if (mins) {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			output += this.pluralPipe.transform(mins, { '=1': '# min', other: '# mins' });
		}
		return output.trim();
	}
}
